import { SET_DATA } from "../actions/types";

const initialState = {
  type: "",
  data: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_DATA:
      return { type: action.payload.type, data: action.payload.data };
    // case SET_VIEW_ID:
    //   return {
    //     ...state,
    //     id: action.payload,
    //   };

    default:
      return state;
  }
}
